import { render, staticRenderFns } from "./CompanyModal.vue?vue&type=template&id=4a9aa1ae&scoped=true&"
import script from "./CompanyModal.vue?vue&type=script&lang=ts&"
export * from "./CompanyModal.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyModal.vue?vue&type=style&index=0&id=4a9aa1ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9aa1ae",
  null
  
)

export default component.exports